import EigenLeadsDiagramFrame from './EigenLeadsDiagramFrame';
import { eigenLeadsPalette, elType } from './eigenLeadsPalette';
import { ElDefs, ElGrid, ElSectionLabel, ElPanel, ElBus, ElConnector } from './eigenLeadsDiagramKit';

const PREFIX = 'elDeliver';

const destinations = [
  { id: 'crm', label: 'CRM', mono: 'salesforce.sync' },
  { id: 'dialer', label: 'Dialer', mono: 'power_queue' },
  { id: 'work', label: 'Work Queue', mono: 'agent_desktop' },
];

const packLines = [
  { field: 'pack_id', value: 'PKG-2401-A' },
  { field: 'territory', value: 'P&C · West' },
  { field: 'contacts', value: '142 ranked' },
  { field: 'cert', value: 'QualityCert™' },
  { field: 'lineage', value: 'source → score → release' },
];

const EigenLeadsDeliveryDiagram = ({ theme = 'dark' }) => {
  const isDark = theme === 'dark';
  const c = eigenLeadsPalette(isDark);

  return (
    <EigenLeadsDiagramFrame
      theme={theme}
      caption="Trusted pack release · documented handoff · available on cadence"
      className="el-deliver-frame"
    >
      <svg viewBox="0 0 720 400" className="w-full h-auto el-deliver-svg" role="img" aria-label="eigenLeads controlled delivery to CRM dialer and work queue">
        <ElDefs prefix={PREFIX} isDark={isDark} />
        <rect width="720" height="400" fill={c.bg} />
        <ElGrid width={720} height={400} c={c} />

        <ElSectionLabel x={360} y={36} c={c}>
          CONTROLLED DELIVERY
        </ElSectionLabel>

        <ElPanel x={48} y={72} w={200} h={280} prefix={PREFIX} c={c} active stroke={c.indigo} className="el-deliver-pack">
          <text x={72} y={100} fill={c.indigo} {...elType.title}>
            RELEASE PACK
          </text>
          <text x={72} y={118} fill={c.mono} {...elType.monoSm}>
            documented · owned
          </text>
          <line x1={72} y1={128} x2={224} y2={128} stroke={c.grid} strokeWidth="1" />
          {packLines.map(({ field, value }, i) => (
            <g key={field} className={`el-deliver-line el-deliver-line-${i}`}>
              <text x={72} y={148 + i * 36} fill={c.muted} {...elType.monoSm}>
                {field}
              </text>
              <text x={72} y={162 + i * 36} fill={c.label} {...elType.mono}>
                {value}
              </text>
            </g>
          ))}
        </ElPanel>

        <ElBus x1={248} y1={212} x2={472} y2={212} prefix={PREFIX} className="el-deliver-bus" />
        <circle r="5" fill={c.emerald} filter={`url(#${PREFIX}-glow)`} className="el-deliver-bus-dot">
          <animateMotion dur="3.5s" repeatCount="indefinite" path="M 248 212 L 472 212" />
        </circle>

        {destinations.map(({ id, label, mono }, i) => {
          const y = 88 + i * 88;
          return (
            <g key={id} className={`el-deliver-dest el-deliver-dest-${i}`}>
              <ElConnector x1={248} y1={212} x2={280} y2={y + 40} c={c} prefix={PREFIX} />
              <ElPanel x={280} y={y} w={160} h={72} prefix={PREFIX} c={c} stroke={c.emerald}>
                <text x={360} y={y + 28} textAnchor="middle" fill={c.label} {...elType.title}>
                  {label}
                </text>
                <text x={360} y={y + 46} textAnchor="middle" fill={c.mono} {...elType.monoSm}>
                  {mono}
                </text>
              </ElPanel>
              <circle cx={360} cy={y + 58} r="3" fill={c.emerald} className={`el-deliver-sync el-deliver-sync-${i}`} />
            </g>
          );
        })}

        <ElPanel x={472} y={72} w={200} h={280} prefix={PREFIX} c={c} stroke={c.emerald}>
          <text x={496} y={100} fill={c.emerald} {...elType.title}>
            PRODUCER VIEW
          </text>
          <text x={496} y={118} fill={c.muted} {...elType.sub}>
            Ranked · verified · contextual
          </text>
          <line x1={496} y1={128} x2={656} y2={128} stroke={c.grid} strokeWidth="1" />
          {[1, 2, 3, 4].map((n, i) => (
            <g key={n} className={`el-deliver-queue el-deliver-queue-${i}`}>
              <rect x={496} y={140 + i * 44} width="160" height="36" rx="4" fill="none" stroke={c.panelStroke} strokeWidth="1" />
              <text x={508} y={158 + i * 44} fill={c.label} {...elType.monoSm}>
                #{n} · score:0.{9 - i}
              </text>
              <text x={508} y={170 + i * 44} fill={c.muted} {...elType.sub}>
                verified · intent attached
              </text>
            </g>
          ))}
          <text x={572} y={340} textAnchor="middle" fill={c.emerald} {...elType.monoSm}>
            dial with confidence
          </text>
        </ElPanel>

        <ElPanel x={48} y={368} w={624} h={24} prefix={PREFIX} c={c}>
          <text x={72} y={384} fill={c.mono} {...elType.monoSm}>
            cadence: weekly · ownership: program_ops · handoff: traceable
          </text>
        </ElPanel>
      </svg>
    </EigenLeadsDiagramFrame>
  );
};

export default EigenLeadsDeliveryDiagram;
